var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */

/* eslint-disable jsdoc/require-returns */
import { Component, CustomElement, html, Prop, svg, nothing } from '@sick-davinci/ce-decorators';
import { style } from './LegendItem.style';
import { SvgTools } from '../_utils/SvgTools.js';
import { TRANSLATE_SYMBOL } from './LegendSymbols.js';
import { CssTools } from '../_utils/CssTools.js';
/**
 * A legend item consists of a label and a symbol
 *
 * @role internal
 *
 * @example
 * ```
 * <davinci-legend-item ></davinci-legend-item>
 * ```
 */

export let LegendItem = (_dec = Component({
  tag: 'davinci-legend-item',
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Number), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Number), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec(_class = (_class2 = class LegendItem extends CustomElement {
  constructor(...args) {
    super(...args);
    this._symbolRightSVG = '';
    this._symbolLeftSVG = '';

    _initializerDefineProperty(this, "label", _descriptor, this);

    _initializerDefineProperty(this, "smallFont", _descriptor2, this);

    _initializerDefineProperty(this, "symbolSizeLeft", _descriptor3, this);

    _initializerDefineProperty(this, "symbolSizeRight", _descriptor4, this);

    _initializerDefineProperty(this, "disabled", _descriptor5, this);

    _initializerDefineProperty(this, "interactive", _descriptor6, this);
  }

  /**
   * the right-hand symbol as svg
   *
   * @default ''
   */
  get symbolRight() {
    return '';
  }

  set symbolRight(val) {
    this._symbolRightSVG = SvgTools.EMBED_SVG(TRANSLATE_SYMBOL(val, 'BLACK'));
  }
  /**
   * the left-hand symbol as svg
   *
   * @default ''
   */


  get symbolLeft() {
    return '';
  }

  set symbolLeft(val) {
    this._symbolLeftSVG = SvgTools.EMBED_SVG(TRANSLATE_SYMBOL(val, 'BLACK'));
  }
  /**
   * the label of this item
   */


  /**
   * See base class
   */
  render() {
    return html`
      <div class="container">
        ${this._symbolLeftSVG ? this._renderSymbol(this._symbolLeftSVG, this.symbolSizeLeft) : nothing}
        <div class="item_label">${this.label}</div>
        ${this._symbolRightSVG ? this._renderSymbol(this._symbolRightSVG, this.symbolSizeRight) : nothing}
      </div>
    `;
  }

  _renderSymbol(symbol, symbolSize) {
    return svg`<svg width="${symbolSize}" height="${symbolSize}">
    <image width="${symbolSize}" height="${symbolSize}" id="symbol" href="${symbol}"></image>
    </svg>`;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "symbolRight", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "symbolRight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "symbolLeft", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "symbolLeft"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "smallFont", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "symbolSizeLeft", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return CssTools.REM2PIXEL(0.5);
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "symbolSizeRight", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return CssTools.REM2PIXEL(0.5);
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "interactive", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
})), _class2)) || _class);
